import React, { useState } from "react";
import styled from "styled-components";

const Select = styled.select`
  min-width: 90px;
  border: 0px;
  border-right: 1px solid #ccc;
`;

export default function TurnaroundPremiumSetInput({
  turnaroundPremiumSet,
  sample,
  onFocus,
  gridCol = "turnaround",
}) {
  if (!turnaroundPremiumSet || turnaroundPremiumSet.turnaround_premiums.length == 0)
    return null;

  const [_, updateState] = useState(null);

  const options = turnaroundPremiumSet.turnaround_premiums.map(tp => ({
    label: "Day " + tp.turnaround + " / " + tp.premium + "% Premium",
    value: tp.turnaround
  }));

  const updateTurnaround = day => {
    sample.turnaround = day;
    updateState();
  };

  return (
    <div>
      <Select
        value={sample.turnaround}
        onChange={e => updateTurnaround(e.target.value)}
        required={true}
        onFocus={onFocus}
        data-sample-grid-col={gridCol}
      >
        {options.map((item, i) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </Select>
    </div>
  );
}
